import { Device } from '../../providers/device/device';

export type TestType =
  | 'y1564'
  | 'truespeed'
  | 'udp'
  | 'twamp-initiator'
  | 'applicationTest'
  | 'y1731'
  | 'rfc2544'
  | 'network-quality'
  | 'servicecontinuity'
  | 'voip'
  | 'multistep'
  | 'twamp'
  | 'http'
  | 'bert'
  | '';
export type OperationalState =
  | 'stopped'
  | 'running'
  | 'failed'
  | 'queued'
  | 'cancelled'
  | 'aborted'
  | 'unknown'
  | 'finished'
  | 'starting'
  | 'stopping'
  | 'lost'
  | 'ready'
  | 'scheduled';
export type AdministrativeState = 'Enabled' | 'Disabled';
export type RunType = 'on-demand' | 'on-going' | '';
export type State = 'enabled' | 'destroyed' | 'disabled';
export type Model =
  | 'vta'
  | 'vpma'
  | 'vpma-l'
  | 'vqt'
  | 'qt600-10'
  | 'jmep'
  | 'jmep1g'
  | 'jmep10g'
  | 'map2100';
export type Layer = 'L2' | 'L3';

export enum TEST_STATE {
  RUNNING = 'running',
  QUEUED = 'queued',
  STOPPED = 'stopped',
  FINISHED = 'finished',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  ABORTED = 'aborted',
  STARTING = 'starting',
  STOPPING = 'stopping',
  UNKNOWN = 'unknown',
  LOST = 'lost',
  SCHEDULED = 'scheduled',
  READY = 'ready'
}

export enum TestTypeValue {
  Y1564 = 'y1564',
  TRUESPEED = 'truespeed',
  CONTAINER_TRUESPEED = 'container:truespeed',
  UDP = 'udp',
  CONTAINER_UDP = 'container:udp',
  Y1731 = 'y1731-initiator',
  TWAMP = 'twamp-initiator',
  TWAMP_REFLECTOR = 'twamp-reflector',
  TWAMP_LIGHT_REFLECTOR = 'twamp-light-reflector',
  RFC2544 = 'rfc2544',
  NETWORK_QUALITY = 'NQ',
  SERVICE_CONTINUITY = 'servicecontinuity',
  VOIP = 'voip',
  MULTISTEP = 'multistep',
  HTTP = 'http',
  FTP = 'ftp',
  BERT = 'bert'
}

export enum TestTypeDisplayValue {
  Y1564 = 'Y.1564',
  TRUESPEED = 'TrueSpeed',
  UDP = 'UDP',
  Y1731 = 'Y.1731',
  TWAMP = 'TWAMP',
  TWAMP_REFLECTOR = 'TWAMP Reflector',
  TWAMP_LIGHT_REFLECTOR = 'TWAMP Light Reflector',
  RFC2544 = 'RFC2544',
  NETWORK_QUALITY = 'Network',
  SERVICE_CONTINUITY = 'Service',
  VOIP = 'VoIP',
  MULTISTEP = 'Web Transactions',
  HTTP = 'HTTP',
  FTP = 'FTP',
  BERT = 'BERT'
}

export enum TestModeLabel {
  MA_TO_MA = 'Agent to Agent',
  MA_TO_JMEP = 'Agent to JMEP',
  CLIENT_TO_MA = 'Client to Agent',
  LOOPBACK = 'Loopback',
  SEQUENTIAL = 'Sequential Bidirectional',
  CONCURRENT = 'Concurrent Bidirectional',
  UNIDIRECIONAL_A_TO_B = 'Unidirectional A -> B',
  UNIDIRECIONAL_B_TO_A = 'Unidirectional B -> A',
  MA_TO_SERVER = 'Agent to Agent',
  MA_TO_EXTERNAL = 'Agent to External Server URLs',
  UPLOAD = 'Upload',
  DOWNLOAD = 'Download',
  UPLOAD_AND_DOWNLOAD = 'Upload/Download'
}

export enum TestMode {
  MA_TO_MA = 'ma-to-ma',
  MA_TO_JMEP = 'ma-to-jmep',
  CLIENT_TO_MA = 'client-to-ma',
  LOOPBACK = 'loopback',
  SEQUENTIAL = 'sequential-bidirectional',
  CONCURRENT = 'concurrent-bidirectional',
  UNIDIRECIONAL = 'unidirectional',
  DEFAULT = 'default',
  UNIDIRECIONAL_A_TO_B = 'unidirectional-a2b',
  UNIDIRECIONAL_B_TO_A = 'unidirectional-b2a',
  MA_TO_SERVER = 'testpoint-to-testpoint',
  MA_TO_EXTERNAL = 'testpoint-to-server',
  UPLOAD = 'engine-a-to-engine-b',
  DOWNLOAD = 'engine-b-to-engine-a',
  UPLOAD_AND_DOWNLOAD = 'bidirsequential'
}

export enum ScheduledIntervals {
  NONE = 0,
  FIVE_MINUTES = 300,
  FIFTEEN_MINUTES = 900,
  THIRTY_MINUTES = 1800,
  HOUR = 3600,
  DAY = 86400,
  WEEK = 604800
}

export enum RunTypeValue {
  ON_GOING = 'on-going',
  ON_DEMAND = 'on-demand'
}

export enum TestLayerLabel {
  L1 = 'Layer 1',
  L2 = 'Layer 2',
  L3 = 'Layer 3',
  L4 = 'Layer 4'
}

export enum TestLayerValue {
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  L4 = 'L4'
}

export interface ITestList {
  id: string;
  MaId: string;
  topId: string;
  name: string;
  layer: Layer;
  originatorAgent: Device;
  destinationAgent: Device;
  lastUpdateTime: string;
  'expiration-date': string;
  model: Model;
  msg: string;
  phyId: string;
  phyName: string;
  role: string;
  runId: number;
  startTime: string;
  status: OperationalState;
  ttl: number;
  type: TestType;
  vendor: string;
  version: string;
  runType: RunType;
  administrativeState: AdministrativeState;
  'test-list-data': string;
  primary?: ITestList;
  secondary?: Array<ITestList>;
  testConfig?: any;
  config?: any;
}

export interface ITestListData {
  customer: ICustomer;
  layer?: string;
  tpInfo?: {
    id: string;
    ip: string;
    type: string;
    model?: string;
    url?: string;
  }[];
  mode?: string;
  runType?: string;
  proxyConfig?: any;
  interval: number;
  scriptUrl?: string;
  scriptName?: string;
  ipAddressType?: string;
}

export interface IMetaDataItem {
  key: string;
  value: string;
}

export interface IAgentSelector {
  regionName: string;
  id: string;
  alias: string;
  location: {
    name: string;
    url?: string;
    coordinate?: {
      lat: number;
      lon: number;
    };
  };
  bbox: [number, number, number, number];
  visible: boolean;
  isCloudAgent: boolean;
}

export interface ICustomer {
  contact: string;
  email: string;
  name: string;
  phone: string;
}

// a list of filter keywords used in existing filters
// or when configuring advanced-search
export enum FILTER_KEYS {
  SITE = 'site',
  APP = 'app',
  DEVICE = 'device',
  STATUS = 'status',
  TEST_TYPE = 'testtype',
  TEST_NAME = 'monitor'
}
